import { jsx as _jsx } from "react/jsx-runtime";
import BannerText from "./components/BannerText";
import cn from "../../../../utils/cn";
const BannerContent = ({ children, className }) => _jsx("div", { className: cn("flex items-center gap-2.5", className), children: children });
BannerContent.Text = BannerText;
export default BannerContent;
